import styled from 'styled-components';

export const SectionWrap = styled.div`
  padding: 0 0 96px;
`;
